import { Children, cloneElement, PropsWithChildren, ReactElement } from 'react';

import { Item, ItemProps } from './components';
import { getFormattedLength } from './List.helpers';
import List from './List.styles';

import type { ListProps } from './List.d';

const BaseList = ({
  alternateColor,
  children,
  counter = true,
  footer,
  header,
  rounded,
  ...props
}: ListProps) => (
  <List.Component data-testid="list" {...props} data-rounded={rounded}>
    {header ||
      (counter && (
        <List.Header as={6} level={6}>
          {header || getFormattedLength(children)}
        </List.Header>
      ))}

    <div>
      {Children.map(children, (child) => {
        const item = child as ReactElement<PropsWithChildren<ItemProps>>;

        if (item.type !== Item) {
          throw new Error('Children must be of type Item');
        }

        return cloneElement(item, {
          alternateColor,
          header: !!header || counter,
          footer: !!footer,
        });
      })}
    </div>

    {footer && <List.Footer>{footer}</List.Footer>}
  </List.Component>
);

export default BaseList;
